import React from "react"

import { Tabs, TabsList, TabsTrigger } from "@coval/ui"
import { Globe, PhoneCall, Plug } from "lucide-react"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"
import {
  isWebSocketConnectionMode,
  WebSocketConnectionMode,
} from "@/types/api/SimulatorType"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"

interface ConnectionModeToggleProps {
  connectionMode: WebSocketConnectionMode
  onConnectionModeChange: (mode: WebSocketConnectionMode) => void
  disabled?: boolean
  allowTwimlWebhook?: boolean
}

export const ConnectionModeToggle: React.FC<ConnectionModeToggleProps> = ({
  connectionMode,
  onConnectionModeChange,
  disabled = false,
  allowTwimlWebhook = false,
}) => {
  const labelId = React.useId()
  return (
    <div className="space-y-2">
      <FieldLabel id={labelId} tooltip={WEBSOCKET_TOOLTIPS.connectionMode}>
        Connection Mode
      </FieldLabel>
      <Tabs
        value={connectionMode}
        onValueChange={(key) => {
          if (isWebSocketConnectionMode(key)) {
            onConnectionModeChange(key)
          }
        }}
      >
        <TabsList variant="pill" className="w-full" aria-labelledby={labelId}>
          <TabsTrigger
            value={WebSocketConnectionMode.DIRECT}
            variant="pill"
            disabled={disabled}
            className="flex-1"
          >
            <Plug className="w-4 h-4" />
            Direct WebSocket
          </TabsTrigger>
          <TabsTrigger
            value={WebSocketConnectionMode.HTTP_FIRST}
            variant="pill"
            disabled={disabled}
            className="flex-1"
          >
            <Globe className="w-4 h-4" />
            HTTP Setup + WebSocket
          </TabsTrigger>
          {allowTwimlWebhook && (
            <TabsTrigger
              value={WebSocketConnectionMode.TWIML_WEBHOOK}
              variant="pill"
              disabled={disabled}
              className="flex-1"
            >
              <PhoneCall className="w-4 h-4" />
              TwiML Voice Webhook
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>
    </div>
  )
}
